import React, { useMemo } from 'react'
import { A4_PORTRAIT } from 'src/views/Management/Reports/types'
import { ApplicationState } from 'src/store'
import { Empty } from 'src/components/Ant'
import { useSelector } from 'react-redux'
import { TableDiv } from './styles'
import { SectionHeader, TableDetail } from './components'
import { WrapPageContent, WrapPage } from '../../styles'
import { Footer, OptionsBar, TitleReport } from '..'

function R13() {
  const {
    reports: {
      reportsResources: {
        R13Data: { data }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const pages = useMemo(() => {
    if (!data.length && !data.length) {
      return [
        [
          <TitleReport title="web.report.13.title" />,
          <SectionHeader />,
          <Empty />
        ]
      ]
    }

    const tempPages: JSX.Element[][] = []

    let index = 0
    // Make pages //
    do {
      const page: JSX.Element[] = []
      page.push(<TitleReport title="web.report.13.title" />)
      page.push(<SectionHeader />)

      const records = 39
      const maxRecordsPossible = data.slice(index, index + records)
      page.push(
        <TableDiv>
          <TableDetail dataSource={maxRecordsPossible} />
        </TableDiv>
      )
      index += records
      tempPages.push(page)
    } while (index < data.length)
    return tempPages
  }, [data])

  return (
    <>
      <OptionsBar />
      {pages.map((item, index) => (
        <WrapPage key={index} className="print" pageShape={A4_PORTRAIT}>
          <WrapPageContent>
            {item.map((t, i) => (
              <React.Fragment key={i}>{t}</React.Fragment>
            ))}
          </WrapPageContent>
          <Footer pagination={{ x: index + 1, y: pages.length }} />
        </WrapPage>
      ))}
    </>
  )
}

export default R13
